// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__tGozV","detailsBorder":"styles_detailsBorder__2AueK"};